import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

import router from './router'
import {types} from "./actions";

// import {options} from '../options'
import {offline_config} from './offlines/animation'

let _ = require('lodash');

var FlattenJS = require('flattenjs');

Vue.use(Vuex)

export default new Vuex.Store({
    state: {

        // . TO TEST ONLY

        // . to test only

        active_view: '',
        API_ROUTE: backend_host,

        // other
        key: 1,
        url_params: {},
        passed_stages: [],
        loader: true,

        // config variables
        block_navigate: true,
        frontend_mode: frontend_mode,
        wizzard_mode: wizzard_mode,

        // constants
        empty_stages: ['game_play_regular', 'fulfillment'], //stages without visible #
        stages_with_time_limit: ['winner_form', 'doe_form', 'instant_win_approval', 'fulfillment_reward_acceptance', 'fulfillment_winner_form', 'fulfillment_upload_page', 'fulfillment_doe_form'],

        // computed
        stages: [],
        allowed_stages: ['root','sorry','rules'],
        all_pages: [],
        start_point: '',

        // request payloads
        new_jwt: '',
        player_uid: '', //??
        expires_in: '',
        uid: '',
        'prize.description': '',
        'reward_reservation.uid': '',
        'instant_win.is_winner': '',

        config: '',
        default_state: '',
        optional_data: {
            before_start:{
                get:'',
                post:'',
                form:''
            },
            ended:{
                get:'',
                post:'',
                form:''
            },
            gate:{
                get:'',
                post:'',
                form:''
            },
            entry:{
                get:'',
                post:'',
                form:''
            },
            success:{
                get:'',
                post:'',
                form:''
            },
            failed:{
                get:'',
                post:'',
                form:''
            },
            sweepstakes_selection:{
                get:'',
                post:'',
                form:''
            },
            game_play_regular:{
                get:'',
                post:'',
                form:''
            },
            instant_win_approval:{
                get:'',
                post:'',
                form:''
            },
            winner_form:{
                get: {
                    player: {}
                },
                post:'',
                form:''
            },
            doe_form:{
                get:'',
                post:'',
                form:''
            },
            download_page:{
                get:'',
                post:'',
                form:''
            },
            fulfillment:{
                get:'',
                post:'',
                form:''
            },
            fulfillment_reward_acceptance:{
                get:'',
                post:'',
                form:''
            },
            fulfillment_winner_form:{
                get:'',
                post:'',
                form:''
            },
            fulfillment_doe_form:{
                get:{
                    player: ''
                },
                post:'',
                form:''
            },
            fulfillment_upload_page:{
                get:'',
                post:'',
                form:''
            },
        },

        // FORM
        errors: {
            gate: '',
            entry: '',
            winner_form: '',
            doe_form: '',

            fulfillment_winner_form: '',
            fulfillment_doe_form: '',
            fulfillment_upload_page: ''

        },
        fields_values: {
            date_of_birth: '',
            mm: '',
            dd: '',
            yy: '',

            state: '',
            first_name: '',
            last_name: '',
            email: '',
            phone: '',
            tc_accepted: '',
            age_confirmed: '',
            privacy_policies_accepted: '',
            email_optin: '',
            sms_optin: '',
            address1: '',
            address2: '',
            city: '',
            zipcode: '',
            country: '',
            uuid: '',
            uid: '',
            reward_reservation_uid: '',
            // only DOE
            is_confirmed: true,
            phone_daytime: '',
            phone_evening: '',
            doe_date_of_birth: ''
        },


    },
    mutations: {
        save_data(state, payload){

            if(typeof payload.data != 'object'){
                state[payload.key] = payload.data
            }else{
                if(Array.isArray(payload.data)){
                    state[payload.key] = payload.data
                }else{
                    state[payload.key] = {...state[payload.key], ...payload.data};
                }
            }

        },
        push_to_allowed_stages(state,payload){
            if(state.allowed_stages.indexOf(payload) === -1){
                state.allowed_stages.push(payload)
            }
        },
        push_to_passed_stages(state,payload){
            if(state.passed_stages.indexOf(payload) === -1){
                state.passed_stages.push(payload)
            }
        },
        remove_from_passed_stages(state,payload){
            if(state.passed_stages.indexOf(payload) > -1){
                state.passed_stages.splice(state.passed_stages.indexOf(payload),1)
            }
        },
        update_field(state,payload){
            state.fields_values[payload.key] = payload.data
        },
        save_form_errors(state,payload){
            state.errors[payload.stage] = payload.data;
        },
        save_optional_data(state,payload){
            state.optional_data[state.active_view][payload.type] = payload.data
        },
        default_state(state,payload){
            state.default_state = payload.toUpperCase();
        },
    },
    actions: {
        [types.GET_CONFIGS](context){
            axios.get(context.state.API_ROUTE +'/api/v1/'+'config')
              .then(function (response) {

                  context.commit('save_data',{key: 'config',data: response.data})

                  if(offline_dev != undefined && offline_dev === true){
                      context.commit('save_data',{key: 'config',data: offline_config})
                  }else{
                      context.commit('save_data',{key: 'config',data: response.data})
                  }

                  context.dispatch(types.COMPUTE_STAGES)

                  if(context.state.frontend_mode){
                      context.commit('save_data',{key:'allowed_stages',data: context.state.all_pages})
                      context.commit('push_to_allowed_stages','rules')
                      context.commit('push_to_allowed_stages','sorry')
                      context.commit('push_to_allowed_stages','time_passed')
                      context.commit('push_to_allowed_stages','end_point')
                      context.commit('push_to_allowed_stages','animation')
                      context.commit('push_to_allowed_stages','scratch')
                      context.commit('push_to_allowed_stages','rejected')

                  }

                  context.dispatch(types.START_POINT)

                  document.title = context.state.config.data.project.name;

              })
              .catch(function (error) {
              });
        },
        [types.COMPUTE_STAGES](context){
            var stages_list = []
            var stages_computed = {}

            context.state.config.data.stages.forEach(function(stage){

                var stage_fields = {}

                for(var k in stage['fields']) {
                    stage_fields[stage['fields'][k]['name']] = stage['fields'][k]
                }

                stages_computed[stage['name']] = {
                    'fields':stage_fields,
                    'all': stage
                }

                stages_list.push(stage['name']);

            })
            context.commit('save_data',{key:'all_pages',data: stages_list});
            context.commit('save_data',{key:'stages',data: stages_computed});
        },
        [types.START_POINT](context){
            console.log(context.state.active_view)
            let start_point = '';

            if(context.getters.url_params.stage != undefined && context.getters.url_params.stage === 'fulfillment'){
                context.commit('save_data',{key:'uid',data: context.getters.url_params.reward_reservation_uid});
                start_point = 'fulfillment';
            }
            //Gate Bypass
            else if(context.getters.url_params.g === 'f' && context.state.config.data.project.current_status === 'active'){
                start_point = 'entry';
            }
            else if(context.state.config.data.project.current_status === 'active'){
                start_point = context.state.config.data.project.starting_stage;
            }
            else{
                start_point = context.state.config.data.project.current_status;
            }

            context.commit('save_data',{key:'start_point',data: start_point});
            context.commit('push_to_allowed_stages',start_point)

            if(context.state.active_view === 'rules'){
                start_point = context.state.active_view;
            }

            router.push({ name: start_point})

        },
        [types.FIND_AND_SAVE](context,payload){

            let values_table = ['new_jwt','player_uid','uid','expires_in', 'instant_win.is_winner', 'prize.description','reward_reservation.uid']

                var flattened = FlattenJS.convert(payload);

                values_table.forEach(function(key,index){

                    for(let tab_key in flattened){

                        if(tab_key.match('.'+key)){
                            context.commit('save_data',{key: key,data: flattened[tab_key]})
                        }

                    }

                })
        },
        [types.FORM_AUTO_FILL](context,payload){

            for(let field in payload){
                context.commit('update_field',{key: field, data: payload[field]})

                if(field === 'state'){
                    setTimeout(()=>{
                        $('select[name="state"]').trigger('change')
                    },10)
                }

            }

        },
        [types.FORM_DEFAULT_VALUES](context){

                if(Object.keys(context.state.stages[context.state.active_view].fields).length === 0){
                    return
                }

                for (let key in context.state.stages[context.state.active_view].fields) {

                    //** checkboxes
                    if (typeof context.state.stages[context.state.active_view].fields[key].default === 'boolean') {
                            if(context.state.stages[context.state.active_view].fields[key].default === true){
                                context.commit('update_field',{key:key, data:1})
                            }else{
                                context.commit('update_field',{key:key, data:''})
                            }
                    }
                    else if(context.state.stages[context.state.active_view].fields[key].default != null ){
                        context.commit('update_field',{key:key, data: context.state.stages[context.state.active_view].fields[key].default })
                    }
                }
        }
    },
    getters: {
        default_state: state => {
            return state.default_state;
        },
        form_data: state=>{
            let form_data = _.clone(state.fields_values)
            // console.log(form_data)
            form_data.phone = form_data.phone? String(form_data.phone).replace(/-|[(]|[)]/gi,''):'';
            form_data.phone_evening = form_data.phone_evening? String(form_data.phone_evening).replace(/-|[(]|[)]/gi,''):'';
            form_data.phone_daytime = form_data.phone_daytime? String(form_data.phone_daytime).replace(/-|[(]|[)]/gi,''):'';

            let doe_date_of_birth = form_data.doe_date_of_birth.split('/');
            if(typeof doe_date_of_birth[0] == "string" && typeof doe_date_of_birth[1] == "string" && typeof doe_date_of_birth[2] == "string"){
                doe_date_of_birth = doe_date_of_birth[2]+'-'+doe_date_of_birth[0]+'-'+doe_date_of_birth[1]
            }else{
                doe_date_of_birth = ''
            }

            form_data.date_of_birth = form_data.doe_date_of_birth? doe_date_of_birth : form_data.date_of_birth;
            form_data.sweeps_param = state.default_state ? state.default_state : null;

            return form_data
        },
        current_year: state => {
            return new Date().getFullYear();
        },
        today_date: state=>{
            let today = new Date();
            let dd = today.getDate();
            let mm = today.getMonth() + 1; //January is 0!
            let yyyy = today.getFullYear();

            if (dd < 10) {
                dd = '0' + dd;
            }

            if (mm < 10) {
                mm = '0' + mm;
            }

            today = mm + '/' + dd + '/' + yyyy;
            return today;
        },
        game_type: state => {
            if (state.stages.game_play_regular != undefined && state.stages.game_play_regular.all.game_type != undefined){
                return state.stages.game_play_regular.all.game_type?state.stages.game_play_regular.all.game_type:''
            }else{
                return ''
            }
        },
        url_params: state=>{
            let a = location.href.split('?');
            if(a[1]){
                var b = a[1].split('#')[0].split('&')
                var c = {}
                for(var i=0;i<b.length;i++){
                    c[b[i].split('=')[0]]=b[i].split('=')[1]
                }
                return c
            }
            else{
                return ''
            }
        },
        valid_time: state=>{

            let valid_time = {
                d: 0,
                h: 0,
                m: 0,
                s: 0,
            }

            if(state.expires_in === ''){
                return valid_time
            }else{

                let distance = state.expires_in * 1000;
                let timer={}

                timer.d = Math.floor(distance / (1000 * 60 * 60 * 24))<10? '0'+Math.floor(distance / (1000 * 60 * 60 * 24)): Math.floor(distance / (1000 * 60 * 60 * 24));
                timer.h = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))<10 ? '0'+Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)):Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                timer.m = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))<10? '0'+Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)):Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                timer.s = Math.floor((distance % (1000 * 60)) / 1000)<10?'0'+Math.floor((distance % (1000 * 60)) / 1000):Math.floor((distance % (1000 * 60)) / 1000);

                return timer
            }


        },
        page_address: state => {
            return window.location.origin + window.location.pathname
        },
        // passed_stages: [],

    }

})


